import React from 'react'
import Calendar from '../../../assets/icons/calendar.png'

export const CalendarIcon = () => <img src={Calendar} alt="Ícone calendário" />
